import styled from "styled-components";
import { BorderColors } from "@abel-technologies-as/components";

const ModalBody = styled.div`
	margin-top: 10px;
`;

const Devider = styled.div`
	border-bottom: 1px solid ${BorderColors.Secondary};
`;

const StyleButton = styled.button`
	background-color: unset;
	outline: none;
	border: 0;
	max-width: 149px;
	cursor: pointer;
	margin-bottom: 16px;
`;

export { ModalBody, Devider, StyleButton };
